import { ModalManager, SimpleModal } from '@studyportals/modal';

/* eslint-disable @typescript-eslint/no-non-null-assertion */
export class LocalizationSettingsModal {
	private popup: null | SimpleModal;
	private popupConfig: any;
	private module: HTMLElement;

	constructor() {
		this.module = document.getElementById('LocalizationSettings')!;
		this.popup = null;

		this.popupConfig = {
			destroyOnClose: false,
			cssClassName: 'LocalizationSettingsModal',
			onOpen: (): void => {
				document.dispatchEvent(
					new CustomEvent('profile_questionnaires_initialize', {
						detail: {
							identifier: 'localization_settings'
						}
					})
				);
			}
		};

		document.addEventListener('localization_settings_buttons_rebind', () => {
			this.bindClickEvents();
		});

		this.init();
	}

	init(): void {
		if (typeof window['ModalManager'] === 'undefined') {
			window['ModalManager'] = new ModalManager();
		}

		this.popup = new SimpleModal(this.module, this.popupConfig);

		this.bindClickEvents();
		this.bindOpenLocalizationSettingsEvent();
	}

	bindClickEvents(): void {
		const prefButtons = document.getElementsByClassName('js-showLocalizationPreferences');
		Array.from(prefButtons).forEach((prefButton) => {
			prefButton.removeEventListener('click', () => {
				window['ModalManager'].open(this.popup!);
			});

			prefButton.addEventListener('click', () => {
				window['ModalManager'].open(this.popup!);
			});
		});
	}

	bindOpenLocalizationSettingsEvent(): void {
		document.addEventListener('open_localization_settings', (): void => {
			window['ModalManager'].open(this.popup!);
		});
	}
}

new LocalizationSettingsModal();
